<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jkgf2G/tc-custom/9781488011559.jpg?1708053344375" alt="This image is the cover for the book Magnate's Mail-Order Bride, The McNeill Magnates"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Magnate's Mail-Order Bride, The McNeill Magnates
      </h1>
      <p class="bookDescription body article font2">
        <b>A matchmaking mix-up throws a famous ballerina and a wealthy businessman into a fake engagement in this steamy romance by the <i>USA Today</i>–bestselling author . . .</b><br/><br/>Ballerina Sofia Koslov’s career is on the line when she’s accosted at the airport by a rich, reckless playboy—who thinks she’s his mail-order bride! But the playboy’s levelheaded brother, Quinn McNeill, solves the media snafu with a switcheroo. He’ll pretend to be her legitimate fiancé to protect her reputation—and to protect his family’s business deals from her billionaire father’s wrath.<br/><br/>Sofia’s one condition: they’ll share the spotlight as a loving couple but won’t share a bed. But soon Quinn’s gentlemanly ways strike a chord, and Sofia’s dying to renege on that condition and have a real fling . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanne Rock
      </h2>
      
      <p class="authorDescription body article">Four-time RITA nominee Joanne Rock has penned over seventy stories for Harlequin.&#160;An optimist by nature and perpetual seeker of silver linings, Joanne finds romance fits her life outlook perfectly--love is worth fighting for.&#160;A former Golden Heart recipient, she has won numerous awards for her stories. Learn more about Joanne&#39;s imaginative Muse by visiting her website <a href="http://www.joannerock.com">www.joannerock.com</a>&#160;or @JoanneRock6 on Twitter.<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36735e3e